import { Pipe, PipeTransform } from '@angular/core';
import { Customer } from '../../classes/customer';

@Pipe({
  name: 'customerGlobalSearchFilter',
  pure: false
})
export class CustomerGlobalSearchFilterPipe implements PipeTransform {

  transform(customerList: Array<Customer>, filterValue: string): any {
    if (!customerList || !filterValue) {
      return customerList;
    }

    const normalizedFilter = filterValue.toLowerCase().trim();
    return customerList.filter(customer => {
      const id = String(customer.IDCustomer ?? '').toLowerCase();
      const companyName = (customer.CompanyName || '').toLowerCase();
      const name = (customer.Name || '').toLowerCase();
      const surname = (customer.Surname || '').toLowerCase();
      const vatNumber = (customer.VATNumber || '').toLowerCase();
      const fiscalCode = (customer.FiscalCode || '').toLowerCase();
      const atecoCode = (customer.AtecoCode || '').toLowerCase();
      const reaNumber = (customer.REANumber || '').toLowerCase();
      const email = (customer.emails || [])
        .map(row => (row?.Email || '').trim())
        .join(' ')
        .toLowerCase();
      const pec = (customer.PEC || '').toLowerCase();
      const headOffice = (customer.HeadOffice || '').toLowerCase();
      const city = (customer.City || '').toLowerCase();
      const phone = (customer.Phone || '').toLowerCase();
      const mobilePhone = (customer.MobilePhone || '').toLowerCase();

      return id.indexOf(normalizedFilter) !== -1
        || companyName.indexOf(normalizedFilter) !== -1
        || name.indexOf(normalizedFilter) !== -1
        || surname.indexOf(normalizedFilter) !== -1
        || vatNumber.indexOf(normalizedFilter) !== -1
        || fiscalCode.indexOf(normalizedFilter) !== -1
        || atecoCode.indexOf(normalizedFilter) !== -1
        || reaNumber.indexOf(normalizedFilter) !== -1
        || email.indexOf(normalizedFilter) !== -1
        || pec.indexOf(normalizedFilter) !== -1
        || headOffice.indexOf(normalizedFilter) !== -1
        || city.indexOf(normalizedFilter) !== -1
        || phone.indexOf(normalizedFilter) !== -1
        || mobilePhone.indexOf(normalizedFilter) !== -1;
    });
  }

}
